<template>
  <div class="w-dvw h-dvh">
    <UApp :toaster="{ position: 'top-right' }">
      <NuxtLoadingIndicator
        :color="'#7BB123'"
        :height="6"
        :throttle="0" />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UApp>
  </div>
</template>
<script setup lang="ts"></script>
